import type { ComponentProps, FC } from 'react';

import { NoResults as UiNoResults } from '@truvhq/ui';
import { clsx } from 'clsx';

/**
 * The kit's empty state, which is a fixed 478px wide and so overflows a phone. Capped at the width
 * it is given, and centered on a phone, where it otherwise hugs the left of a full-width column.
 */
export const NoResults: FC<ComponentProps<typeof UiNoResults>> = ({ className, ...props }) => (
  <UiNoResults className={clsx('max-w-full max-md:mx-auto', className)} {...props} />
);
